import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import PixelLogo from './PixelLogo';

const Navbar = () => {
  const location = useLocation();

  const handleGetStarted = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      document.querySelector('textarea')?.focus();
    }
  };


  return (
    <motion.nav
      initial={{ y: -16, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed top-0 left-0 right-0 z-50 h-12 flex items-center px-6 bg-white/80 backdrop-blur-xl border-b border-[#E2E8F0]/60"
    >
      <div className="w-full flex items-center justify-between">
        <Link to="/" className="flex items-center gap-1.5 group">
          <PixelLogo size={16} color="#2563EB" />
          <span className="text-sm font-bold text-[#0F172A] group-hover:text-[#2563EB] transition-colors">
            prompt<sup className="text-[7px] font-bold text-[#2563EB] tracking-wider animate-pulse ml-1.5" style={{ verticalAlign: 'top', position: 'relative', top: '-2px' }}>BETA</sup>
          </span>
        </Link>

        <div className="flex items-center gap-5">
          <Link to="/agents" className="text-xs font-medium text-[#475569] hover:text-[#0F172A] transition-colors">
            Agents
          </Link>
          <Link to="/pricing" className="text-xs font-medium text-[#475569] hover:text-[#0F172A] transition-colors">
            Pricing
          </Link>
          <Link to="/auth" className="text-xs font-medium text-[#475569] hover:text-[#0F172A] transition-colors">
            Log in
          </Link>
          <Link
            to="/"
            onClick={handleGetStarted}
            className="px-3 py-1.5 rounded-lg bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-xs font-semibold transition-all"
            style={{ boxShadow: '0 2px 8px rgba(37,99,235,0.35)' }}
          >
            Get Started
          </Link>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
